import { inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as actions from '../actions/news.action';
import { switchMap, map, catchError, withLatestFrom } from 'rxjs/operators';
import { NewsService } from '../../services';
import { Go } from 'src/app/store';
import { getNewsPage } from '../selectors';
import { Store } from '@ngrx/store';

export const LoadNewsOverview$ = createEffect(
  (actions$ = inject(Actions), service = inject(NewsService)) => {
    return actions$.pipe(
      ofType(actions.LoadNewsOverview),
      switchMap(({ skip, take }) =>
        service.getNewsOverview(skip, take).pipe(
          map(News => actions.LoadNewsOverviewSuccess({ News })),
          catchError(error => of(actions.LoadNewsOverviewFail({ error })))
        )
      )
    );
  },
  { functional: true }
);

export const LoadMoreNews$ = createEffect(
  (actions$ = inject(Actions), service = inject(NewsService), store = inject(Store)) => {
    return actions$.pipe(
      ofType(actions.LoadMoreNews),
      withLatestFrom(store.select(getNewsPage)),
      switchMap(([{}, page]) =>
        service.getNewsOverview((page.currentPage + 1) * page.pageSize, page.pageSize).pipe(
          map(News => actions.LoadMoreNewsSuccess({ News })),
          catchError(error => of(actions.LoadNewsFail({ error })))
        )
      )
    );
  },
  { functional: true }
);

export const LoadNewsById$ = createEffect(
  (actions$ = inject(Actions), service = inject(NewsService)) => {
    return actions$.pipe(
      ofType(actions.LoadNewsById),
      switchMap(({ id }) =>
        service.getNewsById(id).pipe(
          map(Item => actions.LoadNewsByIdSuccess({ Item })),
          catchError(error => of(actions.LoadNewsByIdFail({ id, error })))
        )
      )
    );
  },
  { functional: true }
);

export const LoadNewsByIdFail$ = createEffect(
  (actions$ = inject(Actions)) => {
    return actions$.pipe(
      ofType(actions.LoadNewsByIdFail),
      map(({ error }) => {
        return Go({ path: ['/' + error?.status ? error.status : '404'], extras: { skipLocationChange: true } });
      })
    );
  },
  { functional: true }
);
